import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  box: {
    padding: '44px 16px 26px 16px',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 18,
    fontWeight: 400,
  },
  subtitle: {
    fontWeight: 600,
    fontSize: 16,
  },
  icon: {
    width: 50,
    height: 70,
    marginRight: 10,
    verticalAlign: 'middle',
  },
  container: {
    marginBottom: 20,
  },
}));

export default useStyles;
